/** Employee gender for PT / payroll (matches Fakhri-api EmployeeGender). */
export type EmployeeGender = "MALE" | "FEMALE";

export const EMPLOYEE_GENDER_CHOICES: { id: EmployeeGender; name: string }[] = [
  { id: "MALE", name: "Male" },
  { id: "FEMALE", name: "Female" },
];

export function employeeGenderLabel(gender: string | null | undefined): string {
  if (!gender) return "—";
  const found = EMPLOYEE_GENDER_CHOICES.find((c) => c.id === gender);
  return found?.name ?? gender;
}

/** Normalize empty date / select values to null for the employees API. */
export function emptyToNull(value: unknown): string | null {
  if (value == null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  return String(value);
}

export type StaffEmployeeFormValues = {
  name?: string;
  phone?: string;
  type?: string | null;
  receiveBookingSummary?: boolean;
  isActive?: boolean;
  joinedOn?: unknown;
  leftOn?: unknown;
  gender?: EmployeeGender | string | null;
};

/**
 * Transform staff create/edit form → API body.
 * Clears empty optional payroll fields so class-validator Matches does not reject "".
 */
export function transformStaffEmployeePayload(
  data: StaffEmployeeFormValues
): StaffEmployeeFormValues {
  return {
    ...data,
    joinedOn: emptyToNull(data.joinedOn),
    leftOn: emptyToNull(data.leftOn),
    gender: emptyToNull(data.gender) as EmployeeGender | null,
  };
}
